/**
 * Remote Toggles Configuration - Feature Toggling, Gradual Rollouts, and Permanent Toggles
 *
 * Use this object to define all feature toggles used in the application.
 * Each toggle must follow the `RemoteToggleType` structure.
 *
 * Example:
 * ```
 * ONTARIO_HEADER: {
 *   key: 'toggle_ontario_header',
 *   trackingKey: 'kjca420',
 *   defaultValue: {
 *     int: true,
 *     prod: false,
 *   },
 * }
 * ```
 * **Key Guidelines:**
 * - `key`: Must start with the prefix `toggle_` followed by a descriptive name for the feature flag.
 * - `trackingKey`: A key prefixed by `kjca` used for tracking. Should align with story JIRA ticket. Optional for Toggles.
 * - `defaultValue`: An object defining the default/fallback values for both integration (`int`) and production (`prod`) environments.
 */
import { type RemoteToggleType } from '@/lib/firebase/types'

export const RemoteToggles = {
  // I need to leave a dummy toggle in to satisfy various typescripts.
  DUMMY_TOGGLE: {
    key: 'toggle_dummy_example',
    defaultValue: { int: true, prod: false },
  },
  DISABLE_OPTIMIZELY_DECIDE_ALL: {
    key: 'toggle_disable_optimizely_decide_all',
    defaultValue: { int: false, prod: false },
    trackingKey: 'kjca4693',
  },
} as const satisfies RemoteToggleType
